module.exports = __WEBPACK_EXTERNAL_MODULE_104__;


//////////////////
// WEBPACK FOOTER
// external "aws-sdk/clients/polly"
// module id = 104
// module chunks = 0